module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwAgMAAAAqbBEUAAAADFBMVEUAAAAmJS4lJS8mJS8z5b45AAAAA3RSTlMA5kyNOJ0PAAAAOUlEQVQoz2OgMpj/Hwq+ATn1MM5fIOc/HNCSQx7gh+n/QAIHTPGTyAGDQclhh3EuADmcME4CldMHAKr7G0mVlf+gAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/helpCenter/archive-fill@2x.png
// module id = 6yKc
// module chunks = 44